// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Znmi","content":"styles_content__2LCl6"};